module.exports = __webpack_public_path__ + "img/sending.fac0eb38.svg";